var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 6,
    viewBox: "0 0 22 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6C1.34182 6 0 4.65818 0 3C0 1.34182 1.34182 0 3 0C4.65818 0 6 1.34182 6 3C6 4.65818 4.65818 6 3 6ZM3 1.63636C2.24727 1.63636 1.63636 2.24727 1.63636 3C1.63636 3.75273 2.24727 4.36364 3 4.36364C3.75273 4.36364 4.36364 3.75273 4.36364 3C4.36364 2.24727 3.75273 1.63636 3 1.63636Z",
    fill: "#171717"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 6C17.3418 6 16 4.65818 16 3C16 1.34182 17.3418 0 19 0C20.6582 0 22 1.34182 22 3C22 4.65818 20.6582 6 19 6ZM19 1.63636C18.2473 1.63636 17.6364 2.24727 17.6364 3C17.6364 3.75273 18.2473 4.36364 19 4.36364C19.7527 4.36364 20.3636 3.75273 20.3636 3C20.3636 2.24727 19.7527 1.63636 19 1.63636Z",
    fill: "#171717"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 6C9.34182 6 8 4.65818 8 3C8 1.34182 9.34182 0 11 0C12.6582 0 14 1.34182 14 3C14 4.65818 12.6582 6 11 6ZM11 1.63636C10.2473 1.63636 9.63636 2.24727 9.63636 3C9.63636 3.75273 10.2473 4.36364 11 4.36364C11.7527 4.36364 12.3636 3.75273 12.3636 3C12.3636 2.24727 11.7527 1.63636 11 1.63636Z",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.c5dc466fb11fdcee96fe26defb88062c.svg";
export { ForwardRef as ReactComponent };